'use strict';

/**
 * Do not edit directly, this file was auto-generated.
 */

var dark = {
  "theme": "dark",
  "surface": {
    "overlayBackdrop": "#00000066",
    "level0": "#141719",
    "level1": "#1d2124",
    "raised": "#141719",
    "overflow": "#141719",
    "inverse": "#e8e9ea",
    "overlay": "#141719",
    "overlayInverted": "#e8e9ea"
  },
  "brand": {
    "googleButtonText": "#1f1f1f",
    "googleButtonBorder": "#f2f2f2",
    "googleButtonFill": "#f2f2f2",
    "fullscriptLogo": "#88b04b",
    "facebookLogo": "#3c5a99",
    "linkedinLogo": "#2867b2",
    "appleButtonText": "#000000",
    "appleButtonBorder": "#ffffff",
    "appleButtonFill": "#ffffff",
    "twitterXLogo": "#ffffff"
  },
  "inverse": {
    "text": "#1d2124",
    "textBold": "#141719",
    "icon": "#1d2124",
    "backgroundMuted": "#e8e9ea",
    "backgroundBold": "#f7f7f7",
    "border": "#f7f7f7"
  },
  "neutral": {
    "textSubtle": "#bcbdbf",
    "text": "#e8e9ea",
    "textBold": "#ffffff",
    "icon": "#e8e9ea",
    "backgroundLevel0": "#141719",
    "backgroundLevel1": "#1d2124",
    "borderMuted": "#1d2124",
    "border": "#686b70",
    "borderBold": "#98999b",
    "separator": "#515357"
  },
  "recur": {
    "text": "#f0d1ff",
    "textBold": "#f2ecfe",
    "icon": "#f0d1ff",
    "backgroundMuted": "#33193f",
    "backgroundBold": "#b990cc",
    "border": "#865c99"
  },
  "critical": {
    "text": "#ffd1dd",
    "textBold": "#feeef2",
    "icon": "#ffd1dd",
    "backgroundMuted": "#451522",
    "backgroundBold": "#ea8aa3",
    "border": "#b23655"
  },
  "info": {
    "text": "#d1e8ff",
    "textBold": "#e6f1fc",
    "icon": "#d1e8ff",
    "backgroundMuted": "#102841",
    "backgroundBold": "#6597ce",
    "border": "#4577ad"
  },
  "warning": {
    "text": "#ffe3d1",
    "textBold": "#fff3e8",
    "icon": "#ffe3d1",
    "backgroundMuted": "#4a2915",
    "backgroundBold": "#cf7945",
    "border": "#ad6234"
  },
  "success": {
    "text": "#f0fff9",
    "textBold": "#fafffc",
    "icon": "#f0fff9",
    "backgroundMuted": "#124935",
    "backgroundBold": "#42ad86",
    "border": "#288563"
  },
  "discovery": {
    "text": "#efe5d1",
    "textBold": "#f6f1e5",
    "icon": "#efe5d1",
    "backgroundMuted": "#493612",
    "backgroundBold": "#bba37c",
    "border": "#6b5024"
  },
  "smart": {
    "backgroundBold1": "#8fa7c1",
    "backgroundBold2": "#b0c1d4",
    "backgroundBold3": "#c8d6e4"
  },
  "accent": {
    "orangeText": "#ffe3d1",
    "orangeTextBold": "#fff3e8",
    "orangeIcon": "#ffe3d1",
    "orangeBackgroundMuted": "#4a2915",
    "orangeBackgroundBold": "#cf7945",
    "orangeBorder": "#ad6234",
    "blueText": "#d1e8ff",
    "blueTextBold": "#e6f1fc",
    "blueIcon": "#d1e8ff",
    "blueBackgroundMuted": "#102841",
    "blueBackgroundBold": "#6597ce",
    "blueBorder": "#4577ad",
    "redText": "#ffd1dd",
    "redTextBold": "#feeef2",
    "redIcon": "#ffd1dd",
    "redBackgroundMuted": "#451522",
    "redBackgroundBold": "#ea8aa3",
    "redBorder": "#b23655",
    "purpleText": "#f0d1ff",
    "purpleTextBold": "#f2ecfe",
    "purpleIcon": "#f0d1ff",
    "purpleBackgroundMuted": "#33193f",
    "purpleBackgroundBold": "#b990cc",
    "purpleBorder": "#865c99",
    "greenText": "#f0fff9",
    "greenTextBold": "#fafffc",
    "greenIcon": "#f0fff9",
    "greenBackgroundMuted": "#124935",
    "greenBackgroundBold": "#42ad86",
    "greenBorder": "#288563"
  },
  "effect": {
    "elevationOverlay": "#ffffff",
    "elevationOverflowColour": "#14171999",
    "elevationRaisedColour": "#14171999",
    "stateFocusedBorder": "#015fcc",
    "stateHoveredBackground": "#ffffff14",
    "stateHoveredText": "#ffffff14",
    "stateHoveredIcon": "#ffffff14",
    "stateHoveredBorder": "#ffffff14",
    "stateHoveredInverseBackground": "#00000014",
    "stateHoveredInverseText": "#00000014",
    "stateHoveredInverseIcon": "#00000014",
    "stateHoveredInverseBorder": "#00000014",
    "stateHoveredInverseBorderBold": "#00000052",
    "stateHoveredBorderBold": "#ffffff52",
    "statePressedBackground": "#ffffff1f",
    "statePressedText": "#ffffff1f",
    "statePressedIcon": "#ffffff1f",
    "statePressedBorder": "#ffffff1f",
    "statePressedInverseBackground": "#0000001f",
    "statePressedInverseText": "#0000001f",
    "statePressedInverseIcon": "#0000001f",
    "statePressedInverseBorder": "#0000001f",
    "statePressedInverseBorderBold": "#000000cc",
    "statePressedBorderBold": "#ffffffcc",
    "stateDisabledOpacity": "0.6",
    "stateReadOnlyOpacity": "0.8"
  },
  "asset": {
    "green_100": "#0c291e",
    "green_200": "#124935",
    "green_300": "#1f5b45",
    "green_400": "#288563",
    "green_500": "#42ad86",
    "green_600": "#bfe8d9",
    "green_700": "#f0fff9",
    "green_800": "#fafffc",
    "green_900": "#ffffff",
    "greenBackground": "#1f5b45",
    "greenBackItem": "#206a4f",
    "red_100": "#290f16",
    "red_200": "#451522",
    "red_300": "#5e1d2e",
    "red_400": "#b23655",
    "red_500": "#c74c6b",
    "red_600": "#ea8aa3",
    "red_700": "#ffd1dd",
    "red_800": "#feeef2",
    "red_900": "#ffffff",
    "redBackground": "#5e1d2e",
    "redBackItem": "#8f2843",
    "purple_100": "#200f29",
    "purple_200": "#33193f",
    "purple_300": "#482359",
    "purple_400": "#865c99",
    "purple_500": "#b990cc",
    "purple_600": "#d8b1ec",
    "purple_700": "#f0d1ff",
    "purple_800": "#f2ecfe",
    "purple_900": "#ffffff",
    "purpleBackground": "#482359",
    "purpleBackItem": "#693b80",
    "orange_100": "#29170c",
    "orange_200": "#4a2915",
    "orange_300": "#63371c",
    "orange_400": "#ad6234",
    "orange_500": "#cf7945",
    "orange_600": "#e7aa84",
    "orange_700": "#ffe3d1",
    "orange_800": "#fff3e8",
    "orange_900": "#ffffff",
    "orangeBackground": "#63371c",
    "orangeBackItem": "#8a4e29",
    "blue_100": "#0c1b29",
    "blue_200": "#102841",
    "blue_300": "#1a3c60",
    "blue_400": "#4577ad",
    "blue_500": "#6597ce",
    "blue_600": "#96bde7",
    "blue_700": "#d1e8ff",
    "blue_800": "#e6f1fc",
    "blue_900": "#ffffff",
    "blueBackground": "#1a3c60",
    "blueBackItem": "#285685",
    "grey_100": "#141719",
    "grey_200": "#1d2124",
    "grey_300": "#22272b",
    "grey_400": "#515357",
    "grey_500": "#98999b",
    "grey_600": "#bcbdbf",
    "grey_700": "#e8e9ea",
    "grey_800": "#f7f7f7",
    "grey_900": "#ffffff",
    "greyBackground": "#515357",
    "greyBackItem": "#2d3238",
    "sand_100": "#000000",
    "sand_200": "#493612",
    "sand_300": "#5e4317",
    "sand_400": "#8e703e",
    "sand_500": "#bba37c",
    "sand_600": "#e2d0ac",
    "sand_700": "#efe5d1",
    "sand_800": "#f6f1e5",
    "sand_900": "#ffffff",
    "sandBackground": "#5e4317",
    "sandBackItem": "#6b5024",
    "shadeWhite": "#141719"
  },
  "button": {
    "primaryDefaultText": "#141719",
    "primaryDefaultBackground": "#e8e9ea",
    "primaryDefaultIcon": "#1d2124",
    "primaryInverseText": "#ffffff",
    "primaryInverseBackground": "#1d2124",
    "primaryInverseIcon": "#e8e9ea",
    "primarySmartText": "#141719",
    "primarySmartIcon": "#1d2124",
    "primaryCriticalText": "#141719",
    "primaryCriticalBackground": "#ea8aa3",
    "primaryCriticalIcon": "#1d2124",
    "secondaryDefaultText": "#ffffff",
    "secondaryDefaultBorder": "#f7f7f7",
    "secondaryDefaultIcon": "#e8e9ea",
    "secondaryInverseText": "#141719",
    "secondaryInverseBorder": "#1d2124",
    "secondaryInverseIcon": "#1d2124",
    "tertiaryDefaultText": "#ffffff",
    "tertiaryDefaultIcon": "#e8e9ea"
  },
  "link": {
    "accentGreenText": "#fafffc",
    "accentGreenIcon": "#f0fff9",
    "defaultText": "#ffffff",
    "defaultIcon": "#e8e9ea"
  },
  "snackbar": {
    "textHeading": "#141719",
    "textBody": "#1d2124",
    "surface": "#e8e9ea"
  },
  "actionTile": {
    "defaultAltBackground": "#141719",
    "defaultAltBorder": "#686b70",
    "defaultAltTextHeading": "#ffffff",
    "defaultAltTextBody": "#e8e9ea",
    "discoveryTextHeading": "#f6f1e5",
    "discoveryBackground": "#493612",
    "discoveryTextBody": "#efe5d1",
    "accentGreenTextBody": "#f0fff9",
    "accentGreenBackground": "#124935",
    "accentGreenTextHeading": "#fafffc",
    "defaultTextBody": "#e8e9ea",
    "defaultBackground": "#1d2124",
    "defaultTextHeading": "#ffffff"
  },
  "drawer": {
    "textBody": "#e8e9ea",
    "textFootnote": "#bcbdbf",
    "textHeading": "#ffffff",
    "surface": "#141719"
  },
  "menu": {
    "textHeading": "#ffffff",
    "textFootnote": "#bcbdbf",
    "surface": "#141719",
    "textBody": "#e8e9ea"
  },
  "popovers": {
    "textBody": "#e8e9ea",
    "textFootnote": "#bcbdbf",
    "surface": "#141719",
    "textHeading": "#ffffff"
  },
  "tooltip": {
    "surface": "#e8e9ea",
    "textHeading": "#141719",
    "textBody": "#1d2124"
  },
  "bottomSheet": {
    "textFootnote": "#bcbdbf",
    "textBody": "#e8e9ea",
    "surface": "#141719",
    "textHeading": "#ffffff"
  },
  "showMoreAccordion": {
    "icon": "#e8e9ea",
    "text": "#ffffff"
  },
  "modal": {
    "textFootnote": "#bcbdbf",
    "surface": "#141719",
    "textBody": "#e8e9ea",
    "textHeading": "#ffffff"
  },
  "accordion": {
    "textHeading": "#ffffff",
    "textSubheading": "#e8e9ea",
    "border": "#686b70",
    "textBody": "#e8e9ea",
    "icon": "#e8e9ea"
  },
  "box": {
    "defaultAlt": "#141719",
    "default": "#1d2124",
    "border": "#686b70",
    "discovery": "#493612",
    "recur": "#33193f"
  },
  "status": {
    "defaultBackground": "#1d2124",
    "defaultText": "#ffffff",
    "defaultIcon": "#e8e9ea",
    "successBackground": "#124935",
    "successText": "#fafffc",
    "successIcon": "#f0fff9",
    "warningBackground": "#4a2915",
    "warningText": "#fff3e8",
    "warningIcon": "#ffe3d1",
    "criticalBackground": "#451522",
    "criticalText": "#feeef2",
    "criticalIcon": "#ffd1dd",
    "infoBackground": "#102841",
    "infoText": "#e6f1fc",
    "infoIcon": "#d1e8ff"
  }
};

exports.dark = dark;
//# sourceMappingURL=dark.cjs.map
